// import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {},
    info: {
      [theme.fn.largerThan('sm')]: {
        alignItems: 'flex-start',
      },
    },
    colLeft: {
      [theme.fn.smallerThan('sm')]: {
        order: 2,
        textAlign: 'center',
      },
      [theme.fn.largerThan('sm')]: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    colRight: {
      // background: `url(${CommonGAssets.getAssetPath(
      //   'airPopulation/not-found-bg.png',
      // )})`,
      // backgroundSize: 'contain',
      // backgroundRepeat: 'no-repeat',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }
})
